import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'react-bootstrap';

const txtFontSize = {
  fontSize: '90%',
};
const lablStyle = {
  marginBottom: '0rem',
};
//a blank small column
const blankColumn = {
  maxWidth: '2rem',
};
const SensorPlacementInfo = ({ placement }) => {
  return (
    <>
      <Col md={1} style={blankColumn} />
      <Col md={4}>
        <Form.Group>
          <Form.Label style={lablStyle}>
            <b>Coordinates</b>
          </Form.Label>
          <br />
          <Row style={txtFontSize}>
            <Col md={6}>
              {'Lat: '}
              {placement.Latitude}
            </Col>
            <Col md={6}>
              {'Long: '}
              {placement.Longitude}
            </Col>
          </Row>
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group>
          <Form.Label style={lablStyle}>
            <b>Sensor Type</b>
          </Form.Label>
          <br />
          <div style={txtFontSize}>{placement.SensorTypeName}</div>
        </Form.Group>
      </Col>
    </>
  );
};

SensorPlacementInfo.propTypes = {
  placement: PropTypes.any.isRequired,
};

export default SensorPlacementInfo;
